export default __webpack_public_path__ + "static/logo-d5b46ebdb2347eedec171b1e6116b6c8.png";